// extracted by mini-css-extract-plugin
export default {"containerBanner":"Banner_containerBanner__WmMpW","section":"Banner_section__+KvNr","scale-in-top":"Banner_scale-in-top__UqB54"};